import React from 'react'
import './Map.css'
import GoogleMap from 'google-map-react'
import { GOOGLE_KEY } from '../../constants'
import marker_image from'../../assets/marker.svg'
const location = {
    address: 'Résidence Ya Zamane 1.',
    lat: 34.06521,
    lng: -6.80776,
} //
export default function Map() {
    return (
        <div className='map'>
            
            <GoogleMap
                bootstrapURLKeys={{ key: GOOGLE_KEY }}
                defaultCenter={location}
                defaultZoom={16}
            >
                <Marker lat={34.06521} lng={-6.80776} text="My Marker" />
            </GoogleMap>
        </div>
    )
}

function Marker() {
    return (
        <div>
            <div className='pin'>
                 <img src={marker_image} alt='logo' width={30} height={30} />
            </div>
            <div className='pulse'></div>



        </div>
    )
}

